exports = module.exports = require("../../../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vote-option{margin:10px auto 0;position:relative;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;background:#fff;border-radius:6px;width:303px;min-height:44px;overflow-x:hidden}.vote-option .vote-icon{position:relative;width:39px!important;height:39px!important;background:#f7f7f7;border-radius:6px;margin:0 0 0 3px}.vote-option .description{position:relative;margin:0 3px 0 12px;font-size:14px;color:#303133;-webkit-box-flex:1;-webkit-flex:1;flex:1}.vote-option .description.has-icon{margin-left:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/component/vote/component/vote-option/scss/index.scss
// module id = 665
// module chunks = 0 1 2 3